import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { useTranslation } from 'app/lang';
import type { PaymentMethodsData } from 'app/packages/brand/get-payments';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import dictionary from './PaymentMethod.dictionary.json';

import styles from './PaymentMethod.module.scss';

type PaymentMethodsProps = {
  paymentMethods: PaymentMethodsData;
};

const PaymentMethods: FC<PaymentMethodsProps> = ({ paymentMethods }) => {
  const { t } = useTranslation();
  const loggedIn = useSelector(selectIsLoggedIn);

  return (
    <ul className={styles.paymentsBlock}>
      <p>{t(dictionary.paymentsTitle)}</p>
      {paymentMethods.map(({ img, paymentId, altImg }) => (
        <li key={paymentId}>
          {loggedIn ? (
            <Link to={`/personal/deposit/${paymentId}`}>
              <img src={img}
                   className={styles.paymentImg}
                   alt={altImg} />
            </Link>
          ) : (
            <img src={img}
                 className={styles.paymentImg}
                 alt={altImg} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default PaymentMethods;
